/* eslint-disable */
const state = {

  // 身份认证信息
  certificationInfo:null,
  // 身份信息变更状态对应传值字段
  changeCertificationInfo: 1,
  analogueMobileMes: [], // 对手方手机号
  ownSideName: '', // 己方手机号
  myAssetBanks: [], // 可选择签约银行列表
  selectBank: null,// 已选择的签约银行
  bankId: null, // 已选择的开户银行id(信息申报)
  marketStatusInNewTopline: '--', // 新页面市场状态
  f10click: 0, // 点击f10
  dlclick: 0, // 点击订立快捷
  zrclick: 0, // 点击转让快捷
  buyclick: 0, // 点击买快捷
  sellclick: 0, // 点击卖快捷
  verticalityclick: 0, // 点击价格/数量快捷
  verticalityclick_up: 0, // 点击上(微调数量/价格)
  verticalityclick_down: 0, // 点击下(微调数量/价格)
}

// getters
const getters = {
  ownSideNameGetter: state => state.ownSideName,
  analogueMobileMesGetter: (state) => state.analogueMobileMes,
  certificationInfoGetter(state) {
    return state.certificationInfo
  },
  changeCertificationInfoGetter(state) {
    return state.changeCertificationInfo
  },
  myAssetBanksGetter(state) {
    return state.myAssetBanks
  },
  selectBank(state) {
    return state.selectBank
  },
  bankId(state) {
    return state.bankId
  },
  marketStatusInNewTopline(state) {
    return state.marketStatusInNewTopline
  },
  f10click(state) {
    return state.f10click
  },
  dlclick(state) {
    return state.dlclick
  },
  zrclick(state) {
    return state.zrclick
  },
  buyclick(state) {
    return state.buyclick
  },
  sellclick(state) {
    return state.sellclick
  },
  verticalityclick(state) {
    return state.verticalityclick
  },
  verticalityclick_up(state) {
    return state.verticalityclick_up
  },
  verticalityclick_down(state) {
    return state.verticalityclick_down
  },
}

// actions
const actions = {

}

// mutations
const mutations = {
  setOwnSideName(state, data) {
    state.ownSideName = data
  },
  setAnalogueMobileMes(state, data) {
    state.analogueMobileMes = data
  },
  setCertificationInfo(state, data) {
    state.certificationInfo = data
  },
  changeCertificationInfo(state, data) {
    state.changeCertificationInfo ++
  },
  myAssetBanks(state, data) {
    state.myAssetBanks = data
  },
  selectBank(state, data) {
    state.selectBank = data
  },
  bankId(state, data) {
    state.bankId = data
  },
  marketStatusInNewTopline(state, data) {
    state.marketStatusInNewTopline = data
  },
  f10click(state, data) {
    state.f10click++
  },
  dlclick(state, data) {
    state.dlclick++
  },
  zrclick(state, data) {
    state.zrclick++
  },
  buyclick(state, data) {
    state.buyclick++
  },
  sellclick(state, data) {
    state.sellclick++
  },
  verticalityclick(state, data) {
    state.verticalityclick++
  },
  verticalityclick_up(state, data) {
    state.verticalityclick_up++
  },
  verticalityclick_down(state, data) {
    state.verticalityclick_down++
  },

}

export default {
  state,
  getters,
  actions,
  mutations
}
